module.exports = __webpack_public_path__ + "static/media/cb-dummy.3d8f827a.jpg";